module.exports = __webpack_public_path__ + "img/door-opened-icon-shadow.257cbdd0.svg";